/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Error_Name_RequiredInputs */



/**
* | output |
* | --- |
* | "Please enter a name for the issue" |
*
* @param {Manual_Qc_Error_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_error_name_required = /** @type {((inputs?: Manual_Qc_Error_Name_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Error_Name_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez saisir un nom pour l'incident")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte geben Sie einen Namen für das Problem ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci un nome per il problema")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, укажите название проблемы.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ingrese un nombre para el problema")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入问题的名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("問題の名前を入力してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया समस्या का नाम दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, insira um nome para o problema.")
	return /** @type {LocalizedString} */ ("Please enter a name for the issue")
});